import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: true
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;

    searchText = searchText.toLowerCase();

    return items.filter(item => {
      return Object.keys(item).some(key => {
        // 檢查是否為字符串或數字
        if (typeof item[key] === 'string' || typeof item[key] === 'number') {
          return String(item[key]).toLowerCase().includes(searchText);
        }

        // 檢查是否為陣列（標籤）
        if (Array.isArray(item[key])) {
          return item[key].some((tag: string) => tag.toLowerCase().includes(searchText));
        }

        return false;
      });
    });
  }
}
